/* global axios */
import ApiClient from './ApiClient';

class BackupAPI extends ApiClient {
  constructor() {
    super('backup', { accountScoped: true });
  }

  // ── Settings ──────────────────────────────────────────────────────────────

  getSettings() {
    return axios.get(`${this.url}/settings`);
  }

  updateSettings(data) {
    return axios.patch(`${this.url}/settings`, { backup_setting: data });
  }

  testConnection() {
    return axios.post(`${this.url}/settings/test_connection`);
  }

  // Trigger an immediate manual backup for all conversations with backup_enabled = true.
  runNow() {
    return axios.post(`${this.url}/settings/run_now`);
  }

  // ── Backups list (all) ────────────────────────────────────────────────────

  getAllBackups(page = 1) {
    return axios.get(`${this.url}/backups/all`, { params: { page } });
  }

  getBackup(id) {
    return axios.get(`${this.url}/backups/${id}`);
  }

  // Returns full conversation + messages data for the read-only chat viewer.
  getViewData(id) {
    return axios.get(`${this.url}/backups/${id}/view_data`);
  }

  deleteBackup(id, deleteFromR2 = false) {
    return axios.delete(`${this.url}/backups/${id}`, {
      params: { delete_from_r2: deleteFromR2 },
    });
  }

  // ── Per-conversation ──────────────────────────────────────────────────────

  getConversationBackups(conversationId) {
    return axios.get(`${this.url}/conversations/${conversationId}/backups`);
  }

  createConversationBackup(conversationId) {
    return axios.post(`${this.url}/conversations/${conversationId}/backups`);
  }

  toggleConversationBackup(conversationId) {
    return axios.patch(`${this.url}/conversations/${conversationId}/toggle`);
  }
}

export default new BackupAPI();
